module.exports = __webpack_public_path__ + "img/Silk-Vista-2-584x584.250903f9.webp";